import { Outlet } from "react-router-dom";
import { AppSidebar } from "./app-sidebar";
import { AppTopbar } from "./app-topbar";
import { MobileBottomNav } from "./mobile-bottom-nav";
import { BlueprintBackground } from "@/components/design";

export function AppShell() {
  return (
    <div className="flex min-h-screen bg-background">
      <AppSidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <AppTopbar />
        <BlueprintBackground className="flex-1 overflow-auto">
          <main className="mx-auto w-full max-w-7xl p-4 pb-24 md:p-6 md:pb-6">
            <Outlet />
          </main>
        </BlueprintBackground>
        <MobileBottomNav />
      </div>
    </div>
  );
}
